import { Link } from "@tanstack/react-router";

import { EmptyState } from "@/components/empty-state";
import { Button } from "@/components/ui/button";
import { pageTitle, useDocumentTitle } from "@/lib/document-title";

/** Not found, in the library's frame, with a single way back. */
export interface NotFoundProps {
  title?: string;
  description?: string;
  /** Passed by the router's notFound(); unused. */
  data?: unknown;
}

export function NotFound({ title = "Not found", description }: NotFoundProps) {
  useDocumentTitle(pageTitle(title));
  return (
    <div className="content page-gutter py-8">
      <EmptyState
        heading="h1"
        title={title}
        description={description ?? "There is nothing at this address."}
        action={
          <Button asChild variant="secondary">
            <Link to="/" search={{}}>
              Back to the library
            </Link>
          </Button>
        }
      />
    </div>
  );
}
